<script setup>
    import PrimaryButton from '../button/PrimaryButton.vue'
    import { logoutUser } from '@/composables/useAuth'
    import api from '@/utils/api'
    import { useRouter } from 'vue-router'
    import { useToast } from '@/composables/useToast'

    const router = useRouter()
    const { showToast } = useToast()

    const logout = async () => {
        try {
            const response = await api.post('/logout')
        } catch (error)
        {
            console.log(error)
        } finally {
            logoutUser()
            showToast('User logged out!', 'success')
            router.push({
                path: '/'
            })
        }
    }

</script>

<script>
    export default {
        name: 'AppLogout'
    }
</script>

<template>
    <primary-button @click="logout">
        <span>Logout</span>
    </primary-button>
</template>